import React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import Text from '../../Text/Text';
import StepperNavigationBtn from './StepperNavigationBtn';
import { setCreateNewOrderData } from '../../../thunks/coilovers/orders/createNewOrder';
import Input from '../../Input/Input';

const OrderProductForm = () => {
  const dispatch = useDispatch();
  const {
    createNewOrderData: {
      title,
      mpn,
      make,
      model,
      yearRange,
      liftPosition,
      checkoutMessage,
      noteToClient,
    },
  } = useSelector((state) => ({
    createNewOrderData: state.createNewOrder?.data
  }), shallowEqual);

  const inputData = [
    [
      {
        id: 'title',
        value: title,
        placeholder: 'Title',
        multiline: false
      },
      {
        id: 'mpn',
        value: mpn,
        placeholder: 'MPN',
        multiline: false
      }
    ],
    [
      {
        id: 'make',
        value: make,
        placeholder: 'Make',
        multiline: false
      },
      {
        id: 'model',
        value: model,
        placeholder: 'Model',
        multiline: false
      },
      {
        id: 'yearRange',
        value: yearRange,
        placeholder: 'Year range',
        multiline: false
      }
    ],
    [
      {
        id: 'liftPosition',
        value: liftPosition,
        placeholder: 'Lift Position',
        multiline: false
      }
    ],
    [
      {
        id: 'checkoutMessage',
        value: checkoutMessage,
        placeholder: 'Checkout message',
        multiline: true,
      },
      {
        id: 'noteToClient',
        value: noteToClient,
        placeholder: 'Note to client',
        multiline: true,
      }
    ]
  ];

  return (
    <div className="flex flex-col flex-1">
      <div className="pb-[50px]">
        <Text text="Product Details" textStyle="text-[20px] text-[#252F4A] mb-[6px]" />
      </div>
      <div>
        {inputData?.map((items, index) => (
          <div className="mb-[30px]" key={['section', index].join('_')}>
            <div className="flex flex-row gap-[20px]">
              {items?.map(({
              id, value, placeholder, multiline, type, required
              }) => (
                <div className="flex1" key={id}>
                  <Text
                    text={placeholder}
                    textStyle="text-[#252F4A] text-[14px]"
                    styleContainer="mb-[10px]"
                    required={required}
                  />
                  <Input
                    type={type || 'text'}
                    name={id}
                    value={value}
                    placeholder={placeholder}
                    multiline={multiline}
                    rows={3}
                    onChange={({ target: { value: val } }) => dispatch(setCreateNewOrderData({ [id]: val }))}
                  />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <StepperNavigationBtn next="client" prev="details" />
    </div>
  );
};

export default OrderProductForm;
